// Emit a single "locationchange" event on every client-side navigation, so pages
// that read URL identifiers (/editor/:id, /highlights?id=) can re-read them WITHOUT
// a remount. `pushState`/`replaceState` don't fire any event natively, and React
// reuses a mounted page when only the route param or query changes.
//
// This is what the Reshet WordPress embed needs: the CMS iframe stays mounted
// across in-app navigations, so pages that read their id only at mount otherwise
// keep showing the first-loaded item — the editor shows "the last one" and a
// highlight deep-link falls back to the normal list.
let installed = false;

export function installHistoryObserver() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  for (const method of ["pushState", "replaceState"]) {
    const original = window.history[method].bind(window.history);
    window.history[method] = (...args) => {
      const result = original(...args);
      window.dispatchEvent(new Event("locationchange"));
      return result;
    };
  }
  // Back/forward and any manually-dispatched popstate also count as a nav.
  window.addEventListener("popstate", () =>
    window.dispatchEvent(new Event("locationchange")),
  );
}
